export default __webpack_public_path__ + "static/media/paper-plane-solid.57094fe6.svg";